import { OrganizationInvitationResponse } from "../contracts/OrganizationInvitationResponse";
import { OrganizationInvitationPreviewResponse } from "../contracts/OrganizationInvitationPreviewResponse";
import { OrganizationInvitationStatus } from "../enums/OrganizationInvitationStatus";
import { OrganizationInvitation } from "../models/OrganizationInvitation";
import { OrganizationInvitationPreview } from "../models/OrganizationInvitationPreview";

const isInvitationExpired = (
  status: OrganizationInvitationStatus,
  expiresAt: string
): boolean => {
  if (status === OrganizationInvitationStatus.Expired) {
    return true;
  }
  return new Date(expiresAt).getTime() < Date.now();
};

/**
 * Maps organization invitation responses from the API to frontend models.
 */
export class OrganizationInvitationResponseMapper {
  /**
   * Converts an OrganizationInvitationResponse to an OrganizationInvitation model.
   */
  toInvitation = (
    resp: OrganizationInvitationResponse
  ): OrganizationInvitation => {
    return {
      id: resp.id,
      organizationId: resp.organizationId,
      email: resp.email,
      role: resp.role,
      status: resp.status,
      expiresAt: resp.expiresAt,
      isExpired: isInvitationExpired(resp.status, resp.expiresAt),
      invitedByInstructorId: resp.invitedByInstructorId,
      dateCreated: resp.dateCreated,
    };
  };

  /**
   * Converts an array of OrganizationInvitationResponse to models.
   */
  toInvitations = (
    responses: OrganizationInvitationResponse[]
  ): OrganizationInvitation[] => responses.map(this.toInvitation);

  /**
   * Converts the anonymous preview response to its frontend model.
   */
  toPreview = (
    resp: OrganizationInvitationPreviewResponse
  ): OrganizationInvitationPreview => {
    return {
      organizationName: resp.organizationName,
      email: resp.email,
      role: resp.role,
      status: resp.status,
      expiresAt: resp.expiresAt,
      isExpired: isInvitationExpired(resp.status, resp.expiresAt),
    };
  };
}
